var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_box"},[_c('div',{staticClass:"footer"},[_c('span',[_vm._v(" Copyright© 1998-"+_vm._s(new Date().getFullYear())+" DRCnet.com.cn All Rights Reserved (建议浏览器：ie9+、火狐、谷歌) ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }